import { Button } from "@material-ui/core"
import { useDispatch, useSelector } from "react-redux"
import { generarCompraAereoAction, obtenerGruposClaveViajeAction } from "../../../ducks/aereosDuck"
import { DialogMessage } from "../../../global/DialogMessage"
import { ToastMessage } from "../../../global/ToastMessage"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
const BotonValidarAereo = (props) => {
    const { idCuenta, idMoneda, idPaquete } = props
    const { grupo } = useSelector(store => store.aereos)
    const dispatch = useDispatch()
    const handleClick = () => {
        DialogMessage.fire({
            title: '¿Esta seguro de validar la información de aereo?',
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "Validando aereo..." }))
                dispatch(generarCompraAereoAction({ idCuenta, idMoneda, idPaquete })).then(Response => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema con el servidor",
                        })
                        return null
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response.Message,
                        })
                        return null
                    }
                    dispatch(onLoadAnction({ message: "Cargando grupos aereos..." }))
                    dispatch(obtenerGruposClaveViajeAction({ claveViaje: grupo.ClaveViaje })).then(() => {
                        dispatch(offLoadAction())
                    })
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    })
                })
            }
        })
    }
    return (
        <div>
            <Button variant="outlined" color="primary" onClick={handleClick}>
                Validar Aereo
            </Button>
        </div>
    )
}
export default BotonValidarAereo